module.exports = __webpack_public_path__ + "img/13.ab202876.png";